/**
 * Códigos de erro de CAMPANHA que atravessam back → front.
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const CAMPAIGN_ERRORS = {
  /**
   * 404 — campanha não é da empresa de quem pediu, ou não existe (#4481).
   * O valor é o que o backend já lançava como string solta; a constante
   * mantém os dois lados falando a mesma coisa.
   */
  NOT_FOUND: "ERR_NO_CAMPAIGN_FOUND",
} as const;

export type CampaignErrorCode = (typeof CAMPAIGN_ERRORS)[keyof typeof CAMPAIGN_ERRORS];
